import React from "react";
import { Row, Col } from "reactstrap";
import { useVendor } from "../Store/VendorStore"; // Assuming reviews come from here

// Component for Rating Breakdown
const RatingBreakdown = () => {
  const { reviews } = useVendor(); // Assuming you get all reviews from the store

  // Calculate the count of reviews for each star rating (5 stars to 1 star)
  const getStarCounts = () => {
    const starCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

    // Count how many reviews exist for each star rating
    reviews.forEach((review) => {
      starCounts[review.Rating] += 1;
    });

    return starCounts;
  };

  // Calculate total reviews for percentage calculation
  const totalReviews = reviews.length;
  const starCounts = getStarCounts();

  return (
    <Row className="justify-content-center">
      <Col style={{ padding: 0 }} xs={11} sm={11} md={10} lg={10}>
        {[5, 4, 3, 2, 1].map((star) => (
          <RatingRow
            key={star}
            star={star}
            count={starCounts[star]}
            percentage={((starCounts[star] / totalReviews) * 100).toFixed(1)} // Calculate percentage
          />
        ))}
      </Col>
    </Row>
  );
};

// Component for Rating Row
const RatingRow = ({ star, count, percentage }) => (
  <Row className="align-items-center" style={{ marginTop: "6px" }}>
    <Col xs={2} md={2} lg={2} className="left-width">
      <h4 className="text-muted text-style">{star} Star</h4>
    </Col>
    <Col xs={8} md={8} lg={8}>
      <div
        style={{
          width: "100%",
          height: "28px",
          backgroundColor: "#DCDCDC",
          borderRadius: "6px",
          border: "1px solid",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${percentage}%`, // Set width based on percentage
            height: "100%",
            backgroundColor: "#FFCE00",
          }}
        ></div>
      </div>
    </Col>
    <Col xs={2} md={2} lg={2}>
      <h4 className="font-weight-bold text-muted text-style">
        {count}
      </h4>
    </Col>
  </Row>
);

export default RatingBreakdown;
